import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#009bdf',
      contrastText: '#fff'
    },
    secondary: {
      main: '#fb0071',
      contrastText: '#fff'
    }
  },
  overrides: {
    MuiFormControlLabel: {
      root: {
        fontSize: 14
      },
      label: {
        fontSize: 15
      }
    },
    MuiListItemIcon: {
      root: {
        marginRight: 0
      }
    },
    MuiMenuItem: {
      root: {
        fontSize: 14,
        height: 16
      }
    }
  }
})

export default theme
